import { useDispatch } from "react-redux";
import { Menu, MenuItem } from "@mui/material";

import { setServerResponse } from "store/application/application-action";
import embedIcon from "../icons/embed_desktop.svg";
import linkIcon from "../icons/link_desktop.svg";
import RedditIcon from "../icons/reddit_desktop.svg";
import TwitterIcon from "../icons/twitter_desktop.svg";
import DiscordIcon from "../icons/discord_desktop.svg";

import "./ShareMenu.scss";

const ACTIONS = [
  { text: "Copy Link", icon: linkIcon },
  { text: "Embed", icon: embedIcon },
  { text: "Social share:", separator: true },
  { text: "Reddit", icon: RedditIcon },
  { text: "Twitter", icon: TwitterIcon },
  { text: "Discord", icon: DiscordIcon },
];

export const ShareMenu = (props: {
  link: string;
  anchor: HTMLElement;
  onClose: () => void;
  onEmbed: () => void;
}): JSX.Element => {
  const dispatch = useDispatch();

  const onClick = (label: string) => {
    console.debug(`Menu item clicked: ${label}`);

    if (label === "Copy Link" || label === "Discord") {
      navigator.clipboard.writeText(props.link);
      dispatch(setServerResponse("Link copied!"));
      props.onClose();
    } else if (label === "Reddit") {
      const url = `https://www.reddit.com/submit?url=${encodeURIComponent(props.link)}`;
      window.open(url, "_blank");
      props.onClose();
    } else if (label === "Twitter") {
      const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(props.link)}`;
      window.open(url, "_blank");
      props.onClose();
    } else if (label === "Embed") {
      props.onEmbed();
    } else {
      props.onClose();
    }
  };

  return (
    <Menu
      className="shareMenu"
      anchorEl={props.anchor}
      open={true}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
    >
      {ACTIONS.map((el, index) => (
        <div key={index}>
          {el.separator && <p className="separator">{el.text}</p>}

          {!el.separator && el.text && <MenuItem
            onClick={() => {onClick(el.text);}}
          >
            <img src={el.icon} alt="" />
            <span>{el.text}</span>
          </MenuItem>}
        </div>
      ))}
    </Menu>
  );
};
